/**
 * Kosten-Anzeige der Wizard-Kostenvorschau (Schritt 3, `StepCostPreview`).
 * Wording E3: NIE "reserviert" — nur "Geschätzt: ~X Credits" + `costNote`.
 */

import { useTranslation } from 'react-i18next'

import type { EstimateResult } from '@/lib/api/channel-content-bulk'

interface CostSummaryCardProps {
  productCount: number
  channelCount: number
  researchEnabled: boolean
  result?: EstimateResult
}

export function CostSummaryCard({
  productCount,
  channelCount,
  researchEnabled,
  result,
}: CostSummaryCardProps) {
  const { t } = useTranslation()

  return (
    <div className="rounded-lg border border-orange-200 bg-orange-50 p-4 dark:border-orange-800 dark:bg-orange-950/20">
      <p className="text-sm text-neutral-700 dark:text-neutral-300">
        {t('channelContent.wizard.costSummary', {
          products: productCount,
          channels: channelCount,
          pairs: result?.pairs ?? 0,
        })}
      </p>
      {researchEnabled && (
        <p className="text-sm text-neutral-700 dark:text-neutral-300">
          {t('channelContent.wizard.costResearchLine', { count: productCount })}
        </p>
      )}
      <p className="mt-1 text-2xl font-bold text-orange-600 dark:text-orange-400">
        {t('channelContent.runs.creditsEstimated', { count: result?.credits_estimated ?? 0 })}
      </p>
      <p className="mt-2 text-xs text-neutral-500 dark:text-neutral-400">
        {t('channelContent.wizard.costNote')}
      </p>
    </div>
  )
}
